import { put, call } from 'redux-saga/effects'
// import { delay } from 'redux-saga'
import { startSubmit, stopSubmit } from 'redux-form'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons'
import * as actions from '../actions'

export function* handleLogin(action) {

  const {form} = action.payload

  yield put(startSubmit('loginForm'))
  yield put(actions.reducerAppLoading(true))

  const res = yield call(commons.post2, '/bg/login', form) 

  if (res.fetchError) {
    yield put(stopSubmit('loginForm', { _error: '通信処理に失敗しました。' }))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }
  
  if (res.error) {
    const {field, message} = res.error
    yield put(stopSubmit('loginForm', { ...field, _error: message }))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  yield put(stopSubmit('loginForm'))
  yield put(actions.reducerSetAuth(res.result, 1))

  yield put(actions.reducerAppLoading(false))
}

export function* handleFetchLoginState(acton) {

  const res = yield call(commons.get2, '/bg/login') 

  if (res.status && res.status == 401) {
    // yield put(actions.reducerSnackBar(true, 'タイムアウトしました。', colors.red400))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError) {
    yield put(stopSubmit('loginForm', { _error: '通信処理に失敗しました。' }))
    yield put(actions.reducerSetAuth({}, 9))
    return
  }
  
  if (res.error) {
    const {field, message} = res.error
    yield put(stopSubmit('loginForm', { ...field, _error: message }))
    yield put(actions.reducerSetAuth({}, 9))
    return
  }


  yield put(actions.reducerSetAuth(res.result, 1))

}


export function* handleLogout(acton) {

  yield put(actions.reducerAppLoading(true))
  const res = yield call(commons.get2, '/bg/logout') 

  if (res.fetchError) {
  }
  
  if (res.error) {
  }

  yield put(actions.reducerSetAuth({}, 9))
  yield put(actions.reducerAppLoading(false))

}



// WEBPACK FOOTER //
// ./src/sagas/auth.js